import React from "react";
import { Container, Grid, Typography, Card, Paper, Box, Divider } from "@mui/material";
import background4 from '../assets/bg4.png';
import jerash from '../assets/Taba.jpg';
import hotel from '../assets/hotel.jpg';
import flight from '../assets/flight.jpg';
import accommodation from '../assets/Accommodation.jpg';
import guide from '../assets/guide.jpg';
import { useTranslation } from 'react-i18next';
const ServicesD = () => {
  const { t ,i18n} = useTranslation();
  const isArabic = i18n.language === 'ar';
    const services = [
        {
          title: "Flight Reservation",
          description:
            "Skip the hassle of booking flight. \nJust tell us where you want to go and we can settle the rest!",
          image: [flight],
        },
        {
          title: "Hotel Reservation",
          description:
            "We put out clients' comfort first. \nWhenever we book for accommodation, \nwe ensure luxury and convenience.",
          image: [hotel],
        },
        {
          title: "On-Ground Arrangement",
          description:
            "Our experienced staff ensures tailor-made \nsolutions for even the most complicated accommodation needs.",
          image: [accommodation],
        },
        {
          title: "Tourist Guide",
          description:
            "Being in a foreign land can be terrifying. \nOur trained tour guides can make your vacation a lot easier!",
          image: [guide],
        },
      ];
    
      return (
    
        <Container sx={{ textAlign: "center", py: 4 ,backgroundColor: '#ffffff',width: '100%',minWidth: '100%'}}>
          {/* Header Section */}
          <Box
      sx={{
        flexDirection: 'column',
        position: "relative",
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        backgroundColor: "transparent",
      }}
    >
      {/* Fixed Background */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${jerash})`, // ✅ Fix background image
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          zIndex: -1, // ✅ Sends it behind the text
        }}
      />
          <Grid container spacing={4} justifyContent="center" mb={6}>
            <Grid item xs={12} md={6}>
                <Box sx={{ textAlign: { xs: 'center', md: isArabic ? 'right' : 'left' },ml: { xs: '0', md: '90px' }, width: { xs: '100%', md: '50%' },marginLeft: { xs: '0', md: '220px' },marginTop: '20px' }}>
              <Typography variant="h4" fontWeight="bold" color="Black" >{t("Titles.lets_take_adventure")}</Typography>
              <Divider sx={{ backgroundColor: 'primary.main', width: '10vh', height: '3px' ,margin: { xs: '20px auto', md: isArabic ? '20px 0 20px auto' : '20px auto 20px 0'} }} />
              <Typography  color="#5a5c61" sx={{margin: { xs: '20px auto', md: isArabic ? '20px 0' : '20px auto' },lineHeight: '2',marginTop: '10px',fontFamily: 'Noto Sans'}}>
             {t("Descriptions.lets_take_adventure")}
              </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} >

            <Box sx={{ textAlign: { xs: 'center', md: isArabic ? 'right' : 'left' },ml: { xs: '0', md: '90px' },width: { xs: '100%', md: '50%' },marginTop: '20px' }}>
                <Typography variant="h4" color="Black" fontWeight="bold">{t("Titles.what_you_get")}</Typography>
                
                <Divider sx={{ backgroundColor: 'primary.main', width: '10vh', height: '3px' ,margin: { xs: '20px auto', md: isArabic ? '20px 0 20px auto' : '20px auto 20px 0'} }} />
                
                <Typography  color="#5a5c61" sx={{lineHeight: '2',marginTop: '10px',fontFamily: 'Noto Sans'}}>
                {t("Descriptions.what_you_get")}
                </Typography>
                <Typography  color="#5a5c61" sx={{lineHeight: '2',marginTop: '10px',fontFamily: 'Noto Sans'}}>
                {t("Descriptions.what_you_get1")}
                </Typography>
                <Typography  color="#5a5c61" sx={{lineHeight: '2',marginTop: '10px',fontFamily: 'Noto Sans'}}>
                {t("Descriptions.what_you_get2")}
                </Typography>
              </Box>
            </Grid>
          </Grid>
    
          {/* Services Section */}
          <Typography variant="h4" color="Black" fontWeight="bold" mb={4} marginTop={4}>{t("Titles.its_time")}</Typography>
          <Divider sx={{ backgroundColor: 'primary.main', width: '20vh', height: '3px' ,margin:   '20px auto'}} />
          <Grid container spacing={4} >
          {services.map((service, index) => (
  <Grid item xs={12} sm={12} md={6} key={index} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
    <Card sx={{
      marginTop: '30px',
      backgroundColor: "rgba(0, 188, 212, 0.1)",
      border: "2px solid #327d81",
      borderRadius: "16px",
      boxShadow: "0 0 30px rgba(50, 125, 129, 0.8)",
      transition: "all 0.3s ease",
      "&:hover": {
        transform: "translateY(-10px)",
        boxShadow: "0 0 20px rgba(50, 125, 129, 0.8)",
        backgroundColor: "rgba(50, 125, 129, 0.15)",
      },
    }}>
      <Paper elevation={0} sx={{
        height: "12.5rem",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        position: 'relative',
        p: 0
      }}>
        <Box
          component="img"
          src={service.image} // Use service.image instead of service.images
          alt={`${service.title}`}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
          onError={(e) => {
            console.error(`Failed to load image: ${service.image}`);
            e.target.src = '/logo192.png';
          }}
        />
      </Paper>
    </Card>
      <Typography component="div" sx={{
        fontSize: '1.3rem',
        paddingTop: 2,
        textAlign: 'center',
        fontFamily: 'Montserrat',
        color: '#000000',
        fontWeight: 600,
      }}>
        {t(`${service.title}.title`)}
      </Typography>
      <Typography sx={{
        
        whiteSpace: 'pre-line',
        fontSize: '15px',
        letterSpacing: '0.50px',
        width:{xs:'70%',md:'50%'},
        lineHeight: 1.6,
        paddingTop: 2,
        textAlign: 'center',
        color: '#5a5c61',
        fontFamily: 'Noto Sans',
      }}>
        {t(`${service.title}.description`)}
      </Typography>
  </Grid>
))}
            </Grid>
            </Box>
        </Container>
      );
};

export default ServicesD;